import {
  FETCH_ALL_SUBCATEGORIES,
  FETCH_ONE_SUBCATEGORY,
  CLEAR_ALL_SUB_CATEGORIES,
  FETCH_ALL_SUBCATEGORIES_START,
  FETCH_ONE_SUBCATEGORY_START,
} from '../constants/ActionTypes'

const INITIAL_STATE = {
  isLoading: false,
  subcategories: null,
  current_subcategory: null,
  isFetching: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_SUBCATEGORIES_START:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_ALL_SUBCATEGORIES:
      return {
        ...state,
        subcategories: action.payload,
        isLoading: false
      };
    case FETCH_ONE_SUBCATEGORY_START:
      return {
        ...state,
        current_subcategory: null,
        isFetching: true
      };
    case FETCH_ONE_SUBCATEGORY:
      return {
        ...state,
        current_subcategory: action.payload,
        isFetching: false
      };
    case CLEAR_ALL_SUB_CATEGORIES:
      return {
        ...state,
        subcategories: null,
        current_subcategory: null,
        isLoading: false,
        isFetching: false
      };
    default:
      return state;
  }
}
